// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZQR2InYQ{background:none!important;color:inherit!important}.ZQR2InYQ._1doi3FzO *{fill:currentColor;stroke:none}.ZQR2InYQ.WXlVGsSO *{fill:none;stroke:currentColor}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"btn": "ZQR2InYQ",
	"isFavorite": "_1doi3FzO",
	"notFavorite": "WXlVGsSO"
};
module.exports = ___CSS_LOADER_EXPORT___;
